(function () {
    "use strict";

    /* groups common functionality related to arrays manipulation
     * can be expanded
    */

    let app = angular.module("app");

    // The service you'll be calling
    app.factory('modalService', ['$q', '$modal', function ($q, $modal) {

        //define functions used by the modal
        var modalService = {

            //shortcut for a modal with custom options
            options: function (text, title,
                options, optionValues, optionClasses, defaultOption) {

                if (typeof title !== 'string') title = 'Options';

                // Default values is the index of buttons
                if (!optionValues) {
                    optionValues = options.map(function (value, index) { return index; });
                }

                var defered = $q.defer();

                var ctrl = function ($scope, $modalInstance) {
                    $scope.text = text; //the text that will be in the modal window
                    $scope.title = title; //the header text that will be in the modal window
                    $scope.options = options; //an array of strings with the content of all buttons
                    $scope.optionClasses = optionClasses; //the CSS classes each button has (passed to ng-class)
                    $scope.doOption = function (index) {
                        $modalInstance.close(index);
                    };
                };
                ctrl.$inject = ['$scope', '$modalInstance'];

                $modal.open({
                    controller: ctrl,
                    templateUrl: '/views/Shared/NotificationModal.html', //modal template
                    windowClass: 'my-modal-window'
                }).result.then(function (index) { defered.resolve(optionValues[index]) },
                    function (message) {
                        if (message !== 'backdrop click'
                            && message !== void 0) defered.reject('Unknown dismissal of modal.');
                        if (typeof defaultOption !== 'number'
                            || defaultOption < 0 || defaultOption >= optionValues.length) {
                            defered.reject('default');
                        }
                        defered.resolve(optionValues[defaultOption]);
                    });

                return defered.promise;
            },

            //shortcut for a modal with a Yes and Cancel button.
            //default button is Cancel, and will resolve to true or false.
            confirm: function (text, title, option) {
                if (typeof title !== 'string') title = 'Confirm';
                if (!option) option = 'Yes';
                return modalService.options(text, title,
                    ['Cancel', option], [false, true], ['btn-default', 'btn-primary'], 1);
            },

            //shortcut for a modal with just an OK button.
            alert: function (text, title) {
                if (typeof title !== 'string') title = 'Alert';
                return modalService.options(text, title,
                    ['OK'], null, ['btn-primary'], 0).then(angular.noop);
            }
        };
        return modalService;
    }]);
})();

//     -------------  example of calling the alert function  -----------   
//     modalService.alert('This is a message.', 'Alert')
//         .then(function () { // do something on dismiss });

//     -------------  example of calling the confirm function  -----------   
//     modalService.confirm('Confirm this message?', 'Confirm?')
//         .then(function (result) { // do something on confirm });

//     -------------  example of calling the Options function  -----------   
//     modalService.Options('Custom modal', 'Custom title',
//         ['Option 1', 'Option 2', 'And opt 3'], null, ['btn-danger', 'btn-primary'], 2)
//         .then(function (result) {
//            // do something
//         });
